import { Injectable } from '@angular/core';
import { WebAddresses } from '../app.config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, filter, map, Observable, of, tap, throwError } from 'rxjs';
import { report } from '../interfaces/preport';
import { ApiResponse } from '../interfaces/api-response';
import { globalUser } from '../helpers/globalFields';
import { MatSnackBar } from '@angular/material/snack-bar';
import { openSnackBar } from '../helpers/genericFunctions';
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) { }

  /**
   * allows easy switching between production and development webserver addresses for api
   */
  private baseUrl = WebAddresses.tCCTicketServer;

  /**

   */
  private objectToHttpParams(obj: Record<string, any>): HttpParams {
    let params = new HttpParams();
    if (!obj) return params;

    Object.entries(obj).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach(v => params = params.append(key, v));
      } else {
        params = params.set(key, val);
      }
    });
    return params;
  }
  getAll(): Observable<report[]> {
    return this.http.get<{ status: string; message: string; data: report[] }>(
      `${this.baseUrl}/api/preport/findall`,
      { headers: globalUser.getHeaders() }
    ).pipe(
      map(response => {
        return (response.data || []).map(r => ({
          ...r,
          rep_filter: this.mapToHttpParams(r.rep_filter)
        }));
      }),
      tap(() => openSnackBar('Reports loaded successfully', 2000, this.snackBar)),
      catchError(err => {
        openSnackBar('Failed to load reports', 5000, this.snackBar);
        return of([]);
      })
    );
  }

  getById(id: number) {
    return this.http.get<{ status: string; message: string; data: report }>(
      `${this.baseUrl}/api/preport/findbyid/${id}`,
      { headers: globalUser.getHeaders() }
    ).pipe(
      map(response => {
        response.data.rep_filter = this.mapToHttpParams(response.data.rep_filter)
        return (response.data || undefined);
      }),
    );
  }
  /**
   * create new pReport
   */
  create(report: report): Observable<report> {

    const payload = {
      ...report,
      rep_filter: report.rep_filter instanceof HttpParams
        ? this.httpParamsToObject(report.rep_filter)
        : report.rep_filter
    };


    return this.http.post<ApiResponse>(`${this.baseUrl}/api/preport/create`, payload, {
      headers: globalUser.getHeaders()
    }).pipe(
    map(res => res.data) // ✅ extract the actual report
  );

  }
  /**
   * create new pReport
   */
  update(report: report): Observable<report> {


    const payload = {
      ...report,
      rep_filter: report.rep_filter instanceof HttpParams
        ? this.httpParamsToObject(report.rep_filter)
        : report.rep_filter
    };


    return this.http.put<ApiResponse>(`${this.baseUrl}/api/preport/update/${report.id}`, payload, {
      headers: globalUser.getHeaders()
    }).pipe(
      map(res => res.data)
    );

  }



  private httpParamsToObject(params: HttpParams): Record<string, string | string[]> {
    const obj: Record<string, string | string[]> = {};
    params.keys().forEach(key => {
      obj[key] = params.getAll(key) ?? [];
    });
    return obj;
  }

  private mapToHttpParams(filterObj: any): HttpParams {
    let params = new HttpParams();


    let filterList = Object.entries(filterObj).map(([key, value]) => ({ key, value }));

    filterList.forEach(filter => {
      if (Array.isArray(filter["value"])) {
        filter["value"].forEach(filterValue => {
          params = params.append(filter["key"], filterValue)
        });
      }
    })

    return params;
  }

  delete(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.baseUrl}/api/preport/deletebyid/${id}`, {
      headers: globalUser.getHeaders()
    });
  }

}
